import { render } from "./PayWithPayoButton.vue?vue&type=template&id=5151c862&ts=true"
import script from "./PayWithPayoButton.vue?vue&type=script&lang=ts"
export * from "./PayWithPayoButton.vue?vue&type=script&lang=ts"

import "./PayWithPayoButton.vue?vue&type=style&index=0&id=5151c862&lang=scss"

import exportComponent from "/github/workspace/customer/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__